import { CheckboxChecked, CheckboxEmpty, CheckboxIndeterminate } from '@ori-ui/icons';
import React from 'react';
const MuiCheckbox = {
  icon: /*#__PURE__*/React.createElement(CheckboxEmpty, null),
  indeterminateIcon: /*#__PURE__*/React.createElement(CheckboxIndeterminate, null),
  checkedIcon: /*#__PURE__*/React.createElement(CheckboxChecked, null)
};
export default MuiCheckbox;